import React, { useState, useRef } from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Building2, Heart, Briefcase, Users, TrendingUp, Loader2, CheckCircle2, MessageCircle, Mail, Phone } from 'lucide-react';
import { sendViaWeb3Forms } from '../services/web3formsService';
import { saveSubmission } from '../services/databaseService';
export function DonatePage() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    email: '',
    telephone: '',
    message: ''
  });
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.firstName.trim()) {
      alert('Veuillez entrer votre prénom.');
      return;
    }
    if (!formData.lastName.trim()) {
      alert('Veuillez entrer votre nom.');
      return;
    }
    if (!formData.email.trim() || !formData.email.includes('@')) {
      alert('Veuillez entrer une adresse email valide.');
      return;
    }
    setIsProcessing(true);
    try {
      const fields: Record<string, string> = {
        prenom: formData.firstName,
        nom: formData.lastName,
        email: formData.email,
        telephone: formData.telephone,
        organisation: formData.companyName,
        message: formData.message
      };
      await sendViaWeb3Forms({
        type: 'don',
        fields
      });
      setIsProcessing(false);
      setIsSuccess(true);
      window.scrollTo(0, 0);
    } catch (error) {
      console.error('Error submitting donation inquiry:', error);
      setIsProcessing(false);
      alert('Une erreur est survenue. Veuillez réessayer.');
    }
  };
  if (isSuccess) {
    return <Layout data-id="element-824">
        <SEO {...pageSEO.donate} data-id="element-825" />
        <div className="min-h-[60vh] flex items-center justify-center bg-gray-50 px-4 py-12" data-id="element-826">
          <Card className="max-w-md w-full text-center p-10 shadow-lg border-t-4 border-t-[#1E88E5]" data-id="element-827">
            <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-828">
              <CheckCircle2 className="w-10 h-10 text-green-600" data-id="element-829" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-830">
              Merci pour votre générosité !
            </h2>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-831">
              Votre demande a bien été enregistrée. Un membre de l'équipe ADCC
              vous contactera très prochainement pour organiser votre don et
              répondre à vos questions.
            </p>
            <Button onClick={() => {
            setIsSuccess(false);
            setFormData({
              firstName: '',
              lastName: '',
              companyName: '',
              email: '',
              telephone: '',
              message: ''
            });
          }} className="w-full text-lg py-6" data-id="element-832">
              Fermer
            </Button>
          </Card>
        </div>
      </Layout>;
  }
  return <Layout data-id="element-833">
      <SEO {...pageSEO.donate} data-id="element-834" />
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-835">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-836">
          <span className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1 text-sm font-medium text-blue-200 mb-4" data-id="element-837">
            Faire un don
          </span>
          <h1 className="text-4xl font-bold mb-4" data-id="element-838">Soutenez l'ADCC</h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-839">
            Votre contribution permet de financer nos actions de formation et
            d'accompagnement vers l'emploi digne au Bénin.
          </p>
        </div>
      </div>

      <div className="bg-gradient-to-b from-[#2C3E50] to-white pb-12" data-id="element-840">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-841">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 text-white text-center border border-white/20" data-id="element-842">
            <h2 className="text-2xl font-bold mb-2" data-id="element-843">Votre impact concret</h2>
            <p className="text-lg font-semibold" data-id="element-844">
              Soutenez l'insertion professionnelle durable.
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-845">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-846">
          <Card className="bg-blue-50 border-blue-100" data-id="element-847">
            <CardContent className="p-6 text-center" data-id="element-848">
              <Users className="w-8 h-8 text-[#1E88E5] mx-auto mb-4" data-id="element-849" />
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-850">Développer</h3>
              <p className="text-sm text-gray-600" data-id="element-851">
                Financer des ateliers de renforcement de capacités de qualité.
              </p>
            </CardContent>
          </Card>
          <Card className="bg-blue-50 border-blue-100" data-id="element-852">
            <CardContent className="p-6 text-center" data-id="element-853">
              <Briefcase className="w-8 h-8 text-[#1E88E5] mx-auto mb-4" data-id="element-854" />
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-855">Insérer</h3>
              <p className="text-sm text-gray-600" data-id="element-856">
                Soutenir les dispositifs de placement et mise en relation avec
                employeurs.
              </p>
            </CardContent>
          </Card>
          <Card className="bg-blue-50 border-blue-100" data-id="element-857">
            <CardContent className="p-6 text-center" data-id="element-858">
              <TrendingUp className="w-8 h-8 text-[#1E88E5] mx-auto mb-4" data-id="element-859" />
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-860">Suivre</h3>
              <p className="text-sm text-gray-600" data-id="element-861">
                Accompagner les bénéficiaires après leur placement pour garantir
                la durabilité.
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Impact Statement */}
        <div className="bg-gradient-to-r from-[#1E88E5] to-[#1976D2] rounded-2xl p-8 text-white mb-12" data-id="element-862">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-863">
            <div data-id="element-864">
              <p className="text-3xl font-bold mb-2" data-id="element-865">50€</p>
              <p className="text-sm text-blue-100" data-id="element-866">
                Finance le matériel pédagogique pour 2 bénéficiaires
              </p>
            </div>
            <div className="border-t md:border-t-0 md:border-l border-white/20 pt-6 md:pt-0" data-id="element-867">
              <p className="text-3xl font-bold mb-2" data-id="element-868">150€</p>
              <p className="text-sm text-blue-100" data-id="element-869">
                Forme et place 1 bénéficiaire
              </p>
            </div>
            <div className="border-t md:border-t-0 md:border-l border-white/20 pt-6 md:pt-0" data-id="element-870">
              <p className="text-3xl font-bold mb-2" data-id="element-871">500€</p>
              <p className="text-sm text-blue-100" data-id="element-872">
                Soutient le dispositif de placement pendant 1 mois
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-873">
          <div className="lg:col-span-2" data-id="element-874">
            <Card data-id="element-875">
              <CardContent className="p-8" data-id="element-876">
                <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-877">
                  Faites un don à l'ADCC
                </h2>
                <p className="text-gray-600 mb-6" data-id="element-878">
                  Remplissez ce formulaire et notre équipe vous contactera pour
                  organiser votre contribution.
                </p>
                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-879">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-880">
                    <div data-id="element-881">
                      <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-882">
                        Prénom *
                      </label>
                      <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleInputChange} required disabled={isProcessing} className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-883" />
                    </div>
                    <div data-id="element-884">
                      <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-885">
                        Nom *
                      </label>
                      <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleInputChange} required disabled={isProcessing} className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-886" />
                    </div>
                  </div>

                  <div data-id="element-887">
                    <label htmlFor="companyName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-888">
                      Entreprise / Organisation (optionnel)
                    </label>
                    <div className="relative" data-id="element-889">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-890">
                        <Building2 className="h-5 w-5 text-gray-400" data-id="element-891" />
                      </div>
                      <input type="text" id="companyName" name="companyName" value={formData.companyName} onChange={handleInputChange} disabled={isProcessing} className="w-full pl-10 rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-892" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-893">
                    <div data-id="element-894">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-895">
                        Email *
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleInputChange} required disabled={isProcessing} className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-896" />
                    </div>
                    <div data-id="element-897">
                      <label htmlFor="telephone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-898">
                        Téléphone
                      </label>
                      <input type="tel" id="telephone" name="telephone" value={formData.telephone} onChange={handleInputChange} disabled={isProcessing} placeholder="+229..." className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-899" />
                    </div>
                  </div>

                  <div data-id="element-900">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-901">
                      Votre message (optionnel)
                    </label>
                    <textarea id="message" name="message" value={formData.message} onChange={handleInputChange} disabled={isProcessing} rows={4} placeholder="Précisez le type de soutien que vous souhaitez apporter, le montant envisagé, ou toute question..." className="w-full rounded-md border-gray-300 shadow-sm focus:border-[#1E88E5] focus:ring-[#1E88E5] p-2 border disabled:opacity-50" data-id="element-902" />
                  </div>

                  <Button type="submit" className="w-full text-lg py-6" disabled={isProcessing} data-id="element-903">
                    {isProcessing ? <>
                        <Loader2 className="w-5 h-5 mr-2 animate-spin" data-id="element-904" />
                        Envoi en cours...
                      </> : <>
                        <Heart className="w-5 h-5 mr-2" data-id="element-905" />
                        Envoyer ma demande de don
                      </>}
                  </Button>
                </form>
              </CardContent>
            </Card>
          </div>

          <div className="space-y-6" data-id="element-906">
            <Card className="bg-blue-50 border-none" data-id="element-907">
              <CardContent className="p-6" data-id="element-908">
                <div className="flex items-center gap-3 mb-4" data-id="element-909">
                  <div className="p-2 bg-[#1E88E5] rounded-full" data-id="element-910">
                    <MessageCircle className="w-5 h-5 text-white" data-id="element-911" />
                  </div>
                  <h3 className="font-bold text-gray-900" data-id="element-912">Prise de contact</h3>
                </div>
                <p className="text-sm text-gray-600 mb-4" data-id="element-913">
                  Après réception de votre formulaire, un membre de l'équipe
                  ADCC vous contactera personnellement pour discuter des
                  modalités de votre don et répondre à toutes vos questions.
                </p>
                <div className="space-y-3" data-id="element-914">
                  <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-915">
                    <Mail className="w-4 h-4 text-[#1E88E5]" data-id="element-916" />
                    <span data-id="element-917">contact@adcc.africa</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-gray-700" data-id="element-918">
                    <Phone className="w-4 h-4 text-[#1E88E5]" data-id="element-919" />
                    <span data-id="element-920">+229 01 59 11 13 30</span>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-gray-50 border-none" data-id="element-921">
              <CardContent className="p-6" data-id="element-922">
                <h3 className="font-bold text-gray-900 mb-2" data-id="element-923">
                  Déduction fiscale
                </h3>
                <p className="text-sm text-gray-600" data-id="element-924">
                  L'ADCC étant une association reconnue, vos dons peuvent ouvrir
                  droit à une déduction fiscale selon la législation en vigueur
                  dans votre pays de résidence. Un reçu fiscal vous sera envoyé
                  automatiquement.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </Layout>;
}